import { Popover } from "antd"
import { ProductModel } from "api/repositories/appTransaction/models/AppTransactionResponseModel"
import { AuthenticationContext } from "context/AuthenticationContext"
import { isEmpty } from "lodash"
import { useEffect, useMemo } from "react"
import { FaInfoCircle } from "react-icons/fa"
import { renderItem } from "utils/helpersInTs/helpersInTs"
import { strings } from "utils/localizedStrings"

export const ProductDetail = (
  { product, Constants, service }: { product: ProductModel, Constants?: any, service?: string }
) => {
  const { config, getConfig } = AuthenticationContext();
  const label = useMemo(() => config?.["productDetail"]?.[service]?.labels, [config, service]);
  const values = useMemo(() => config?.["productDetail"]?.[service]?.values?.filter((item: any) => item?.enable === true), [config, service]);

  function renderTemplate(obj: any, template: string): string {
    return template?.replace(/\$\{([^}]+)\}/g, (_, path) => {
      return getByPath(obj, path.trim()) ?? "";
    });
  }

  function getByPath<T extends object, R = any>(
    obj: T,
    path: string,
    defaultValue: any = ""
  ): R {
    return path?.split(".")?.reduce((acc, key) => {
      if (acc && typeof acc === "object") {
        return (acc as any)[key];
      }
      return defaultValue;
    }, obj);
  }

  useEffect(() => {
    isEmpty(config) && getConfig();
  }, [config])

  return (
    <div className="flex flex-row items-center">
      {renderTemplate(product, label)}
      <Popover
        placement="bottomRight"
        arrow={false}
        trigger={["click"]}
        content={
          <>
            {values?.map((item: any) => renderItem(
              strings.AppTransactionHistory.Labels.ProductLabels?.[item?.label as keyof typeof strings.AppTransactionHistory.Labels.ProductLabels],
              Constants?.productDetail(item?.label, getByPath(product, item?.value))
            ))}
          </>
        }
      >
        <FaInfoCircle className="ml-2 hover:cursor-pointer" />
      </Popover>
    </div>
  );
};